namespace Matrix.Workflow {
    export interface WorkflowInstanceListRequest extends Serenity.ListRequest {
        ApprovalQueue?: boolean;
        QueueCode?: string;
    }
}
